var Component = require("!./../../../../.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../../.1.0.35@vux-loader/src/script-loader.js!./../../../../.10.3.0@vue-loader/lib/selector?type=script&index=0!./swiper-item.vue"),
  /* template */
  require("!!./../../../../.10.3.0@vue-loader/lib/template-compiler?id=data-v-5cc5d243!./../../../../.1.0.35@vux-loader/src/template-loader.js!./../../../../.10.3.0@vue-loader/lib/selector?type=template&index=0!./swiper-item.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/.2.0.17@vux/src/components/swiper/swiper-item.vue
// module id = 135
// module chunks = 2